import PropTypes from 'prop-types';

export default {
	id: PropTypes.string.isRequired,
	display_name: PropTypes.string.isRequired,
	reference: PropTypes.string.isRequired,
	to_account: PropTypes.shape({
		name: PropTypes.string.isRequired,
		sort_code: PropTypes.string,
		account_number: PropTypes.string,
		iban: PropTypes.string,
	}).isRequired,
	singleUse: PropTypes.bool,
};
